var $827e42814bc8f58e$exports = {};
$827e42814bc8f58e$exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};


export {$827e42814bc8f58e$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
